import { UseQueryResult } from '@tanstack/react-query';

export type Nullable<T> = T | null;

export type QueryResults<T extends readonly unknown[]> = {
  [K in keyof T]: UseQueryResult<T[K]>;
};

export enum MessageType {
  Info,
  Warning,
  Success,
  NotDefined,
}

export type ServerResponse<T> = {
  errorMessage: string;
  result: T;
  messageType: MessageType;
  timeGenerated: string;
};

export enum SubmissionStatus {
  Pending = 0,
  InProgress = 1,
  Failed = 2,
  Completed = 3,
  Deleting = 4,
}

export type OSType = 'win' | 'mac';

export enum MappingSortingStatus {
  notMapped,
  mapped,
  all,
}

export type PageViewModel = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  pageNumber: number;
  totalItems: number;
  totalPages: number;
};

export type MappingTableItem = {
  id: number;
  typeCode: string;
  type: Nullable<{
    id: number;
    type: string;
  }>;
  typeCodeDesc: Nullable<string>;
  isMapped: boolean;
};

export enum OrderBy {
  none,
  desc,
  asc,
}

export type MappingData = {
  isDataAvailable: boolean;
  countNotMapped: number;
  count: number;
  pageViewModel: PageViewModel;
  tableData: MappingTableItem[];
};

export type MappingTypeItem = {
  id: number;
  type: string;
};

export type MappingTypeItemBody = {
  typeCode: string;
  typeId: number;
  typeCodeDesc: Nullable<string>;
};

export type MappingResponse = ServerResponse<{ types: MappingTypeItem[] }>;

export enum MappingType {
  loans = 'loans',
  shares = 'shares',
  pfc = 'pfc',
}
